import { render } from "./Auth.vue?vue&type=template&id=49f8a080&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=49f8a080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f8a080"]])

export default __exports__